import { green, red } from '@material-ui/core/colors'

// TODO BUG Must set font or no-script pages wont show correct font.
// This is do to some sort of an escape bug rendering that put &quote vs " in css.

export default {
  typography: {
    fontFamily: ['Roboto'],
  },
  palette: {
    primary: green,
    accent: red,
    type: 'dark',
    background: {
      appBar: '#33333',
    },
  },
}



// WEBPACK FOOTER //
// /Users/evank/Documents/dev/kyle.ventures/src/Theme.js